import $ from 'jquery'

//call this function after each time keyboard open for iOS build
export const setWebViewAfterKeyBoard = (event) => {
    console.log("on Blur setWebViewAfterKeyBoard");
    event.preventDefault();
    document.body.scrollTop = 0;
    window.scrollTo(0, 0);
}

export const setWebViewOnWidgetStart = () => {
    // console.log("setKeyboard it");
    // //document.getElementById("tv-ctl").scrollTop = 0;
    // document.getElementById("tv-ctl").scrollTo({
    //     top: 0,
    //     left: 0
    // });
    // $(window).scrollTop($('#tv-ctl').offset().top);
    // $('.tv-controls').scrollTop(0);
    // //$('.columns').scrollTo(0, 0);
    // document.body.scrollTop = 0;
    // window.scrollTo(0, 0);
}